"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthErrorCode = void 0;
var AuthErrorCode;
(function (AuthErrorCode) {
    AuthErrorCode["INVALID_IDENTIFIER"] = "invalid-identifier";
    AuthErrorCode["INVALID_EMAIL"] = "invalid-email";
    AuthErrorCode["INVALID_PASSWORD_CONFIRMATION"] = "invalid-password-confirmation";
    AuthErrorCode["INVALID_PASSWORD"] = "invalid-password";
    AuthErrorCode["INVALID_USERNAME"] = "invalid-username";
    AuthErrorCode["INVALID_URL"] = "invalid-url";
    AuthErrorCode["INVALID_CODE"] = "invalid-code";
    AuthErrorCode["USER_NOT_FOUND"] = "user-not-found";
    AuthErrorCode["EMAIL_NOT_EXIST"] = "email-not-exist";
    AuthErrorCode["EMAIL_UNCONFIRMED"] = "email-unconfirmed";
    AuthErrorCode["EMAIL_IS_TAKEN"] = "email-is-taken";
    AuthErrorCode["NOT_MERCHANT"] = "not-merchant";
})(AuthErrorCode = exports.AuthErrorCode || (exports.AuthErrorCode = {}));
//# sourceMappingURL=authErrorCode.js.map